<!-- 
  -- Projet: Gestion des stagiaires
  -- Auteur : Tim Allemann
  -- Date : 16.09.2020
  -- Description : Formulaire de suppression d'une affiliation
  -- Fichier : DeleteTypeJobSearchAssistance.vue
  -->

<template>
  <v-form
    ref="formDeleteTypeJobSearchAssistance"
    v-model="validCreatetypeJobSearchAssistance"
    lazy-validation
  >
    <v-dialog v-model="dialog" max-width="600px">
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          v-bind="attrs"
          v-on="on"
          tile
          color="red"
          dark
          min-width="150"
          class="ma-2"
        >
          Supprimer
        </v-btn>
      </template>
      <v-card>
        <v-card-title>
          <span class="headline">Supprimer une occurence ARE</span>
        </v-card-title>
        <v-card-text>
          <h3 class="mb-3">
            Attention une suppression est définitive !
          </h3>
          <v-card
            class="mx-auto"
            tile
            v-if="
              typeJobSearchAssistanceOccurence.jobSearchAssistances.length > 0
            "
          >
            <v-list disabled>
              <v-subheader
                >Il faut supprimer le type ARE liée aux ARE avant de pouvoir
                supprimer l'ARE</v-subheader
              >
              <v-list-item-group
                v-model="typeJobSearchAssistanceOccurence.jobSearchAssistances"
                color="primary"
              >
                <v-list-item
                  v-for="(type,
                  i) in typeJobSearchAssistanceOccurence.jobSearchAssistances"
                  :key="i"
                >
                  <v-list-item-content>
                    <v-list-item-title
                      name="description"
                      v-text="type.description"
                    ></v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-card>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="dialog = false">
            Fermer
          </v-btn>
          <v-btn
            color="red darken-1"
            text
            @click="DeleteTypeJobSearchAssistance()"
            v-if="
              typeJobSearchAssistanceOccurence.jobSearchAssistances.length == 0
            "
          >
            Supprimer
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-form>
</template>

<script>
import store from '@/store/index.js'
import NProgress from 'nprogress'

export default {
  props: {
    typeJobSearchAssistanceOccurence: {
      type: Object,
      required: true
    }
  },

  data: () => ({
    validCreatetypeJobSearchAssistance: true,
    dialog: false
  }),

  methods: {
    // Supprime une affiliation
    DeleteTypeJobSearchAssistance() {
      NProgress.start()
      store
        .dispatch(
          'typeJobSearchAssistanceOccurrence/deletetypeSearchAssistanceOccurrence',
          this.typeJobSearchAssistanceOccurence
            .typeJobSearchAssistanceOccurrenceId
        )
        .then(() => {
          this.$router.push({
            name: 'TypeJobSearchAssistanceOccurences'
          })
        })
        .catch(() => {})
      this.dialog = false
      NProgress.done()
    }
  }
}
</script>
